import Vue from "vue";
import axios, { AxiosInstance } from "axios";

// @NOTICE Authorization header will be set in @core/auth/jwt/jwtService via @/auth/jwt/useJwt. Should not be in @core...
const axiosInstance: AxiosInstance = axios.create({
    baseURL: process.env.VUE_APP_PUBLIC_API,
    headers: {
        "Access-Control-Allow-Origin": "*",
        "Access-Control-Allow-Methods": "OPTIONS,GET,POST,PATCH,PUT,DELETE",
        "Access-Control-Allow-Headers": "Content-Type",
        "x-api-key": "x-api-key-saysimple-frontend",
    },
});

Vue.prototype.$http = axiosInstance;

export default axiosInstance;
